import React, { useEffect, useState } from "react";
import DropdownSelect from "../DropdownSelect";
import { Accordion, Card } from "react-bootstrap";
import trashIcon from "../../../assets/images/icons/trash-icon.svg";
import saveIcon from "../../../assets/images/icons/save.svg";
import editIcon from "../../../assets/images/icons/mode_edit.svg";
import moment from 'moment';
import flashIcon from "../../../assets/images/flash_icon.svg";
import exitIcon from "../../../assets/images/ex-red.svg";
import { getHourArray, getMinArray, setCutOffTime } from "../utils";

const NewOfferComponent = (props) =>{

    const {
        id,
        offerDetailsSelected,
        setOffersConsolidation,
        offersConsolidation,
        idx,
        handleDeleteOffer,
        activeKey,
        setActiveKey,
        handleClickHeader,
        showError,
        setShowError,
        hasSelectionError,
        handleAddNewOffer,
        isCheckedApplyAll,
        classificationOptions,
        dutyAssigOptions,
        selectedClassification,
        selectedDutyAssig,
        isFlashOffer,
        setShowCDAError,
        selectedDates,
        availableDates,
        stationTime
    } = props;

    const [showCutOffTime, setShowCutOffTime] = useState(false);
    const [editCutOffTime, setEditCutOffTime] = useState(false);
    const [cutOffHr, setCutOffHr] = useState("");
    const [cutOffMin, setCutOffMin] = useState("");
    const [cutOffFlashOfferMin, setCutOffFlashOfferMin] = useState("");
    const [dateSelectedEdit, setDateSelectedEdit] = useState("");
    const [cutOffTimeSelected, setCutOffTimeSelected] = useState({
        date: "",
        time: ""
    });
    const [cutOffDate, setCutOffDate] = useState("");
    const [cutOffError, setCutOffError] = useState(false);  

    const handleSlotChange = (valueOrEvent) => {
        let previousOffers = { ...offersConsolidation };
        let currentOffer = { ...offersConsolidation[offerDetailsSelected.id] };
    
        let newSlotCount =
            typeof valueOrEvent === "object"
                ? parseInt(valueOrEvent.target.value || "0", 10)
                : currentOffer.slots + valueOrEvent; 
    
        if (isNaN(newSlotCount) || newSlotCount < 1 || newSlotCount > 99) return;
    
        currentOffer.slots = newSlotCount;
        previousOffers[currentOffer.id] = currentOffer;
        setOffersConsolidation(previousOffers);
    };

    const handleClickSave = (offerId) => {
        if (!isCheckedApplyAll) {
            if (!offersConsolidation[offerId]?.classification || !offersConsolidation[offerId]?.dutyAssignment) {
                let previousOffers = {...offersConsolidation};
                let currentOffer = {...offersConsolidation[offerId]};
                currentOffer.cdaError = true;
                setShowCDAError(true);
                previousOffers[offerId] = currentOffer;
                setOffersConsolidation(previousOffers);
                return
            }
        }
        if (!hasSelectionError(offerId)) {
            if (offersConsolidation[offerId]?.error) {
                return
            } else {
                setActiveKey(null);
            }
        }
    }

    const handleSelect = (keyChanged, value) => {
        let previousOffers = {...offersConsolidation};
        let currentOffer = {...offersConsolidation[offerDetailsSelected.id]};
        currentOffer[keyChanged] = value;
        previousOffers[offerDetailsSelected.id] = currentOffer;
        setOffersConsolidation(previousOffers);
    }

    const handleTimeChange = (keyChanged, valueChanged) => {
        let previousOffers = {...offersConsolidation};
        let currentOffer = {...offersConsolidation[offerDetailsSelected.id]};
        currentOffer[keyChanged] = valueChanged;
        previousOffers[offerDetailsSelected.id] = currentOffer;

        const parseTime = (val) => val === "00" || val ? Number(val) : undefined;

        let startMin = parseTime(currentOffer.offerStartTimeMin);
        let startHr = parseTime(currentOffer.offerStartTimeHr);
        let endMin = parseTime(currentOffer.offerEndTimeMin);
        let endHr = parseTime(currentOffer.offerEndTimeHr);

        if (startHr > endHr || (startHr == endHr && startMin > endMin )) {
            currentOffer.note = "NOTE: *This offer will end the following day";
        } else if (currentOffer.note) {
            currentOffer.note="";
        }

        if (selectedDates.includes(moment(stationTime).format("MM/DD/YYYY")) && (startMin=='00' || startMin) && moment(stationTime).add(30, "minutes").isAfter(moment(`${startHr}:${startMin}`, "HH:mm"))) {
            currentOffer.error = "Offer should start at least 30 minutes after current time.";
            setShowError(true);
        }

        if (currentOffer.error === "Offer should start at least 30 minutes after current time." && moment(stationTime).add(29, "minutes").isBefore(moment(`${startHr}:${startMin}`, "HH:mm"))) {
            currentOffer.error = "";
            setShowError(false);
        }

        if (startMin>=0 && endMin>=0 && startHr>=0 && endHr>=0) {
            if (showCutOffTime) {
                currentOffer.cutOffTime = selectedDates.reduce((acc, date) => {
                    acc[date] = setCutOffTime(date, stationTime);
                    return acc;
                }, {})
            }else {
                setShowCutOffTime(true)
            }
            const minStart = startHr? (startHr * 60 ) + startMin : startMin;
            const minEnd = endHr? (endHr * 60)+ endMin : (24 * 60 )+ endMin;
            
            let durationTotalMin = minEnd - minStart;
            if (durationTotalMin < 0) {
                durationTotalMin += 24 * 60;
            }
            const durationHr = Math.floor(durationTotalMin/60);
            const durationMin = durationTotalMin % 60;
            currentOffer.duration = `${String(durationHr).padStart(2,'0')}:${String(durationMin).padStart(2,'0')}`;
        
            if (durationTotalMin < 30 ) {
                currentOffer.error = "Duration time can't be less than 30 minutes.";
                previousOffers[offerDetailsSelected.id] = currentOffer;
                setShowError(true);
            } else if (durationTotalMin > 630 ) {
                currentOffer.error = "Duration time can't be greater than 10.5 hours.";
                previousOffers[offerDetailsSelected.id] = currentOffer;
                setShowError(true);
            } else if (durationTotalMin >= 30 && currentOffer.error) {
                currentOffer.error = false;
                previousOffers[offerDetailsSelected.id] = currentOffer;
                setShowError(false);
            }
        }
        previousOffers[offerDetailsSelected.id] = currentOffer;
        setOffersConsolidation(previousOffers);
        return;
    }

    const handleChangeCutOff = (date, newDate) => {
    
        let currentOffer = {...offersConsolidation[offerDetailsSelected.id]};
        let previousOffers = {...offersConsolidation};
        
        if (!currentOffer.cutOffTime[date]) {
            currentOffer.cutOffTime[date] = setCutOffTime(date, stationTime);
        }
        
        if (!currentOffer.cutOffTime[date].untilDepleted) {
            if (date == moment().format("MM/DD/YYYY")) {
                if (moment(`${offerDetailsSelected.offerStartTimeHr}:${offerDetailsSelected.offerStartTimeMin}`, "HH:mm").subtract(cutOffFlashOfferMin, 'minutes').isBefore(moment("00:00", "HH:mm"))) {
                    currentOffer.cutOffTime[date].date = moment().subtract(1, 'day').format("MM/DD/YYYY");
                } else {
                    currentOffer.cutOffTime[date].date = moment().format("MM/DD/YYYY");
                }
                currentOffer.cutOffTime[date].time = moment(`${offerDetailsSelected.offerStartTimeHr}:${offerDetailsSelected.offerStartTimeMin}`, "HH:mm").subtract(cutOffFlashOfferMin, 'minutes').format("HH:mm");
            
            } else {
                    currentOffer.cutOffTime[date].date = date !== newDate ? newDate : date;
                    currentOffer.cutOffTime[date].time = cutOffHr + ":" + cutOffMin;
                
            }
        }
        previousOffers[offerDetailsSelected.id] = currentOffer;
        setOffersConsolidation(previousOffers);
        setEditCutOffTime(false)
    }

    const handleCutOffCheckbox = (date) => {
        let previousOffers = {...offersConsolidation};
        let currentOffer = {...offersConsolidation[offerDetailsSelected.id]};
        
        if (!currentOffer.cutOffTime[date]) {
            currentOffer.cutOffTime[date] = setCutOffTime(date, stationTime);
        }
        
        if (currentOffer.cutOffTime[date].untilDepleted) {
            currentOffer.cutOffTime[date].untilDepleted = false;
        }
        else {
            currentOffer.cutOffTime[date].untilDepleted = true;
            setCutOffError(false);
        }
        previousOffers[offerDetailsSelected.id] = currentOffer;
        setOffersConsolidation(previousOffers);
    }

    useEffect(()=> {
        if (cutOffDate === dateSelectedEdit && Number(cutOffHr) > Number(offerDetailsSelected.offerStartTimeHr)) {
            setCutOffError(true);
        } else {
            setCutOffError(false);
        }
    },[cutOffHr, cutOffDate, offerDetailsSelected.offerStartTimeHr])

    useEffect(() => {
        if (offerDetailsSelected.error) {
            setShowError(true);
        } else {
            setShowError(false);
        }
    }, [offerDetailsSelected.error]);

    useEffect(() => {
        if (selectedDates.includes(moment(stationTime).format("MM/DD/YYYY"))) {
            props.validateOfferTimes(
                    offerDetailsSelected.offerStartTimeHr,
                    offerDetailsSelected.offerStartTimeMin,
                    moment(stationTime).format("MM/DD/YYYY"))
        }
    }, [offerDetailsSelected.offerStartTimeHr, offerDetailsSelected.offerStartTimeMin]);

    // Guard: if this offer was deleted from consolidation, don't render
    if (!offersConsolidation[offerDetailsSelected.id]) return null;
    
    return (
        <Card key={offerDetailsSelected.id} style={{marginLeft: 10, marginRight: 10}} id="new-offer-card">
            {activeKey!== (offerDetailsSelected.id).toString()&&
            <Card.Header>
            <div id={offerDetailsSelected.id}>
                <div className="shifttype-container">
                    <div className="offer-header-container" onClick={()=>handleClickHeader(offerDetailsSelected.id)}>
                        <div className="header-text" style={{display: 'flex', minWidth: 'fit-content', minWidth: 200}}>
                            <p style={{margin: 0}}>{offerDetailsSelected.offerStartTimeHr}:{offerDetailsSelected.offerStartTimeMin} - {offerDetailsSelected.offerEndTimeHr}:{offerDetailsSelected.offerEndTimeMin}{offerDetailsSelected.note&&"*"}</p>
                            <p className="duration-header" style={{margin: 0, marginLeft: 25, fontWeight: 'bolder'}}>{offerDetailsSelected.duration}</p>
                        </div>
                { 
                offersConsolidation[offerDetailsSelected.id]?.error?.length> 0 ?
                <>
                <p className="error">*{offersConsolidation[offerDetailsSelected.id]?.error}</p>
                </>
                :
                <>
                <div style={{display: 'flex', flexWrap: 'wrap'}}>
                    <div className="header-text slots-header">
                    <p style={{margin: 0}}>{offerDetailsSelected.slots}</p>
                    </div>
                    {isFlashOffer&&<img src={flashIcon}/>}
                </div>
                <div className="header-text offer-header-text-container">
                    <p style={{margin: 0}}>{isCheckedApplyAll ? selectedClassification : offerDetailsSelected.classification}</p>
                    <p style={{margin: 0, marginLeft: 25}}>{isCheckedApplyAll ? selectedDutyAssig : offerDetailsSelected.dutyAssignment}</p>
                </div>
                </>
                }  
                    </div>
                    <div>
                        <img  className="save-button" style={{cursor: 'pointer'}} onClick={()=>handleClickHeader(offerDetailsSelected.id)} src={editIcon}/>
                        <button className="delete-button"  style={{marginLeft: 30}} data-offer-id={offerDetailsSelected.id} id={offerDetailsSelected.id} onClick={(e)=>handleDeleteOffer(e)}>
                            <img src={trashIcon}/>
                        </button>
                    </div>
                </div>
                
            </div>
            </Card.Header>
            }
            
            <Accordion.Collapse eventKey={offerDetailsSelected.id.toString()} >
                <Card.Body>
            {!isCheckedApplyAll&&
            <div className="dropdown-form"   style={{display: "flex", flexWrap: "wrap", marginTop: 30}}>
                <DropdownSelect
                title={"Duty Assignment"}
                options={dutyAssigOptions}
                selectedOption={offerDetailsSelected.dutyAssignment}
                setSelectedOption={(state)=>handleSelect("dutyAssignment", state)}
                isRequired={true}
                isEnabled={true}
                error={offerDetailsSelected.cdaError&&!offerDetailsSelected.dutyAssignment}
                />

                <DropdownSelect
                title={"Classification"}
                options={classificationOptions}
                selectedOption={offerDetailsSelected.classification}
                setSelectedOption={(state)=>handleSelect("classification", state)}
                isRequired={true}
                isEnabled={true}
                error={offerDetailsSelected.cdaError&&!offerDetailsSelected.classification}
                />
            </div>
            
            }
            <div className="dropdown-form"  style={{marginBottom: 20, display: 'flex', flexWrap: "wrap",}}>
                <div className="dropdown-label time-container">
                    <div className="dropdown-label subheader">Start Time</div>
                    <div className="dropdown-form"   style={{display:'flex'}}>
                   
                    <DropdownSelect
                    title={"Hour"}
                    options={
                        (() => {
                            const includesToday = selectedDates.includes(moment(stationTime).format("MM/DD/YYYY"));
                            let startTimeMax = 0;
                            if (includesToday) {
                                let currentTime = moment(stationTime);
                                if (Number(currentTime.format("HH")) < Number(currentTime.add(30, "minutes").format("HH"))) {
                                    startTimeMax = Number(currentTime.add(30, "minutes").format("HH"));
                                } else {
                                    startTimeMax = Number(currentTime.format("HH"));
                                }
                            }
                            return getHourArray(startTimeMax, undefined, "startTime");
                        })()
                    }
                    optionsTrigger={offerDetailsSelected.offerStartTimeHr}
                    selectedOption={offerDetailsSelected.offerStartTimeHr}
                    setSelectedOption={(state)=>handleTimeChange("offerStartTimeHr", state)}
                    isRequired={false}
                    isEnabled={true}
                    width={'small'}
                    />
                
                    <DropdownSelect
                    title={"Minutes"}
                    options={
                        (() => {
                            const includesToday = selectedDates.includes(moment(stationTime).format("MM/DD/YYYY"));
                            let minArray = [];
                            if (includesToday) {
                                let currentTime = moment(stationTime);
                                let currentHour = Number(currentTime.format("HH"));
                                let currentMinutes = Number(currentTime.format("mm"));
                                let offerStartTimeHrNum = Number(offerDetailsSelected.offerStartTimeHr);
                                let minStartHour = Number(currentTime.add(30, "minutes").format("HH"));
                                if (minStartHour < offerStartTimeHrNum || offerStartTimeHrNum > currentHour) {
                                    getMinArray(undefined,undefined,5);
                                } else {
                                    if (offerStartTimeHrNum === currentHour || offerStartTimeHrNum === minStartHour) {
                                        let minMinute = (currentMinutes + 30) % 60;
                                        minMinute = Math.ceil(minMinute / 5) * 5;
                                        for (let i = minMinute; i < 60; i += 5) {
                                            minArray.push(i.toString().padStart(2, '0'));
                                        }
                                    }
                                    else if (minStartHour === currentHour) {
                                        let minMinute = currentMinutes + 30;
                                        minMinute = Math.ceil(minMinute / 5) * 5;
                                        if (minMinute < 60) {
                                            for (let i = minMinute; i < 60; i += 5) {
                                                minArray.push(i.toString().padStart(2, '0'));
                                            }
                                        }
                                    }
                                }
                                return minArray.length > 0 ? minArray : getMinArray(undefined,undefined,5);
                            }
                            return getMinArray(undefined,undefined,5);
                        })()
                    }
                    optionsTrigger={offerDetailsSelected.offerStartTimeHr}
                    selectedOption={offersConsolidation[offerDetailsSelected.id]?.offerStartTimeMin}
                    setSelectedOption={(state)=>handleTimeChange("offerStartTimeMin",state)}
                    isRequired={false}
                    isEnabled={true}
                    width={'small'}
                    />
                    </div>
                        
                </div>
                <div className="dropdown-label time-container">
                    <div className="dropdown-label subheader">End Time</div>
                    <div className="dropdown-form"   style={{display:'flex'}}>
                    <DropdownSelect
                    title={"Hour"}
                    options={getHourArray()}
                    selectedOption={offerDetailsSelected.offerEndTimeHr}
                    setSelectedOption={(state)=>handleTimeChange("offerEndTimeHr",state)}
                    isRequired={false}
                    isEnabled={true}
                    width={'small'}
                    offerDetailsSelected={[offerDetailsSelected,offersConsolidation]}
                    />
                
                    <DropdownSelect
                    title={"Minutes"}
                    options={getMinArray(undefined,undefined,5)}
                    selectedOption={offerDetailsSelected.offerEndTimeMin}
                    setSelectedOption={(state)=>handleTimeChange("offerEndTimeMin",state)}
                    isRequired={false}
                    isEnabled={true}
                    width={'small'}
                    offerDetailsSelected={[offerDetailsSelected,offersConsolidation]}
                    />
                    </div>
                </div>
                <div className="dropdown-label time-container" style={{marginBottom: 20, flexDirection: 'row', alignItems: 'flex-end', fontSize: 16}}>
                    <div className="dropdown-label subheader" style={{margin: 0,fontSize: 16 }}>Duration</div>
                    <div style={{display:'flex', fontSize: 16}}>
                        {offerDetailsSelected.duration}
                    </div>
                </div>
            </div>
                    {offerDetailsSelected.note&&<div className="note">{offerDetailsSelected.note}</div>}
            {showCutOffTime&&<div className="dropdown-form"  style={{marginBottom: 20, display: 'flex', flexWrap: "wrap",flexDirection: 'column'}}>
                <div className="dropdown-label subheader" style={{fontSize: 17, zIndex: 0}}>Cut off Time</div>
                <div style={{display: "flex", flexWrap: "wrap", marginTop: 0, flexDirection: 'column'}}>
                    {selectedDates
                        .filter(date => offerDetailsSelected.cutOffTime && offerDetailsSelected.cutOffTime[date])
                        .map((date, index) => {
                    if (date ==  moment().format("MM/DD/YYYY")) { 
                    return<div key={date+index}>
                        <div  style={{display: "flex" }}>
                            <img src={flashIcon}/>
                            <p className="custom-dropdown-toggle" key={index} style={{margin:0, marginLeft: 10, minWidth: 0, width: "fit-content"}}>{moment(date).format("MM/DD/YYYY")}
                                <span style={{fontFamily: "AmericanSans-Medium"}}>&nbsp;- Cut Off:&nbsp;</span>{editCutOffTime&&dateSelectedEdit==date ? "" : (offersConsolidation[offerDetailsSelected.id]?.cutOffTime[date]?.untilDepleted ? "This offer will close once depleted" : `${offerDetailsSelected.cutOffTime[date]?.date || ''} ${offerDetailsSelected.cutOffTime[date]?.time || ''}`)}</p>
                            {editCutOffTime&&dateSelectedEdit==date?
                            <div style={{display: "flex", gap: 20, height: 30, alignItems: "baseline", marginLeft: 10, cursor: 'pointer'}}>
                            <img onClick={()=>handleChangeCutOff(date)} src={saveIcon}/>
                            <img style={{height: 20}} src={exitIcon} onClick={()=>{setEditCutOffTime(false)}}/>
                            </div>
                            : 
                            <img  onClick={()=>{
                                setEditCutOffTime(true)
                                setDateSelectedEdit(date)
                            } } src={editIcon}/>
                        }
                        </div>

                        {editCutOffTime&&dateSelectedEdit==date&&
                        <div style={{display: "flex", flexDirection: 'column', border: '3px solid #0078d2', borderRadius: 5, margin: 20, padding: 20, gap: 30, maxWidth:400}}>
                            <DropdownSelect
                                title={"Minutes prior to Offer Start Time"}
                                options={["15", "30", "45"]}
                                selectedOption={(offerDetailsSelected.cutOffTime[date]?.untilDepleted) ? "" : cutOffFlashOfferMin }
                                setSelectedOption={(state)=>{
                                    let cutOffTime = moment(`${offerDetailsSelected.offerStartTimeHr}:${offerDetailsSelected.offerStartTimeMin}`, "HH:mm").subtract(state, 'minutes').format("HH:mm");
                                    if (moment(`${offerDetailsSelected.offerStartTimeHr}:${offerDetailsSelected.offerStartTimeMin}`, "HH:mm").subtract(state, 'minutes').isBefore(moment("00:00", "HH:mm"))) {
                                        setCutOffTimeSelected({time : cutOffTime, date : moment().subtract(1, 'day').format("MM/DD/YYYY")});
                                    } else {
                                        setCutOffTimeSelected({time : cutOffTime, date :  moment().format("MM/DD/YYYY")});
                                    }
                                    setCutOffFlashOfferMin(state)
                                    }
                                }
                                isRequired={false}
                                isEnabled={!(offerDetailsSelected.cutOffTime[date]?.untilDepleted)}
                                width={'small'}
                                />
                            {!(offerDetailsSelected.cutOffTime[date]?.untilDepleted) && <div className="note">{cutOffTimeSelected.date} - {cutOffTimeSelected.time}</div>}
                            <div style={{display: "flex", flexWrap: "wrap", alignItems:'center', marginLeft: 10}} onClick={()=>handleCutOffCheckbox(date)}>
                                <input type="checkbox" checked={offerDetailsSelected.cutOffTime[date]?.untilDepleted || false} value="This offer will close once depleted"/>
                                <p style={{fontFamily: "AmericanSans-Regular", margin:0, marginLeft: 10}}>This offer will close once depleted</p>
                            </div>
                        </div>
                        }
                    </div>
                    } else {
                    const now = moment();
                    const currentHour = Number(now.format("HH"));
                    const currentMinute = Number(now.format("mm"));
                    let minStartHour = currentHour;
                    let minStartMinute = 0;

                    if (currentMinute < 30) {
                        minStartMinute = 30;
                    } else {
                        minStartHour = currentHour + 1;
                        minStartMinute = 0;
                    }

                    const startTimeValid = props.validateOfferTimes(
                        offerDetailsSelected.offerStartTimeHr,
                        offerDetailsSelected.offerStartTimeMin,
                        date
                    );

                    return <div key={date+index}>
                        <div style={{display: "flex"}}>
                            <p className="custom-dropdown-toggle" key={index} style={{margin:0, marginLeft: 10, minWidth: 0, width: "fit-content"}}>
                                {date ? moment(date).format("MM/DD/YYYY") : "Invalid Date"}
                                <span style={{fontFamily: "AmericanSans-Medium"}}>&nbsp;- Cut Off:&nbsp;</span>{editCutOffTime&&dateSelectedEdit==date ? "" : (offersConsolidation[offerDetailsSelected.id]?.cutOffTime[date]?.untilDepleted ? "This offer will close once depleted" : `${offerDetailsSelected.cutOffTime[date]?.date || ''} ${offerDetailsSelected.cutOffTime[date]?.time || ''}`)}
                            </p>
                            {editCutOffTime&&dateSelectedEdit==date?
                                <div style={{display: "flex", gap: 20, height: 30, alignItems: "baseline", marginLeft: 10, cursor: 'pointer'}}>
                                    <img onClick={()=>!cutOffError&&handleChangeCutOff(date,cutOffDate)} src={saveIcon}/>
                                    <img style={{height: 20}} src={exitIcon} onClick={()=>{setEditCutOffTime(false)}}/>
                                </div> :
                                <img onClick={() => {
                                    setEditCutOffTime(true);
                                    setDateSelectedEdit(date);
                                    setCutOffDate(offerDetailsSelected.cutOffTime[date]?.date || date);
                                    const timeString = offerDetailsSelected.cutOffTime[date]?.time || "00:00";
                                    const timeParts = timeString.split(":");
                                    setCutOffHr(timeParts[0] || "00");
                                    setCutOffMin(timeParts[1] || "00");
                                }} src={editIcon} />
                            }
                        </div>
                        {(!startTimeValid) && (
                            <p style={{color: "red",fontFamily: "AmericanSans-Regular"}}>
                                *Start time must be at least 30 minutes from current time.
                            </p>
                        )}
                        {editCutOffTime && dateSelectedEdit === date &&<div style={{display: "flex", flexDirection: 'column', border: '3px solid #0078d2', borderRadius: 5, margin: 20, padding: 20, gap: 30, width: 400}}>
                        <div className="cut-off-time-dropdown" style={{display: "flex",gap: 30,}}>
                            <DropdownSelect
                                title={"Date"}
                                options={availableDates.slice(0, availableDates.indexOf(date) + 1)}
                                selectedOption={cutOffDate}
                                setSelectedOption={(state) => {
                                    setCutOffHr("")
                                    setCutOffMin("")
                                    setCutOffDate(state)}}
                                isRequired={false}
                                isEnabled={!(offerDetailsSelected.cutOffTime[date]?.untilDepleted)}
                                width={'small'}
                            />
                            <DropdownSelect
                                title={"Hour"}
                                options={
                                    getHourArray(
                                        (cutOffDate === moment().format("MM/DD/YYYY") && offerDetailsSelected.offerStartTimeHr !== undefined)
                                            ? minStartHour
                                            : undefined,
                                        undefined,
                                        "startTimeHr"
                                    )
                                }
                                selectedOption={cutOffHr}
                                setSelectedOption={(state) => setCutOffHr(state)}
                                isRequired={false}
                                isEnabled={!(offerDetailsSelected.cutOffTime[date]?.untilDepleted)}
                                width={'small'}
                                error={cutOffError && cutOffDate === date && Number(cutOffHr) > Number(offerDetailsSelected.offerStartTimeHr)}
                            />
                            <DropdownSelect
                                title={"Minutes"}
                                options={
                                    getMinArray(
                                        (cutOffDate === moment().format("MM/DD/YYYY") && Number(cutOffHr) === minStartHour)
                                            ? minStartMinute
                                            : undefined,
                                        undefined, 5
                                    )
                                }
                                selectedOption={cutOffMin}
                                setSelectedOption={(state) => setCutOffMin(state)}
                                isRequired={false}
                                isEnabled={!(offerDetailsSelected.cutOffTime[date]?.untilDepleted)}
                                width={'small'}
                                error={cutOffError && cutOffDate === date && Number(cutOffMin) > Number(offerDetailsSelected.offerStartTimeMin)}
                            />
                        </div>
                            {cutOffError&&<p style={{color: "red",fontFamily: "AmericanSans-Regular"}}>*Please choose a valid Cut Off Time/Date.</p>}
                            <div style={{display: "flex", flexWrap: "wrap", alignItems:'center', marginLeft: 10}} onClick={()=>handleCutOffCheckbox(date)}>
                                <input type="checkbox" checked={offersConsolidation[offerDetailsSelected.id]?.cutOffTime[date]?.untilDepleted || false} value="This offer will close once depleted"/>
                                <p style={{fontFamily: "AmericanSans-Regular", margin:0, marginLeft: 10}}>This offer will close once depleted</p>
                            </div>
                        </div>
                        }
                    </div>
                }}
            )}
                </div>
            </div>}
            <div>
                <div className="dropdown-label subheader">Slots</div>
                <div className="slots-container">
                    <button className="button-left"  onClick={(e)=>handleSlotChange(-1)}>-</button>
                    <input   style={{marginLeft: 5, marginRight: 5, width: 25, textAlign: 'center', border: 0}}
                    type="number" 
                    onChange={(e)=>handleSlotChange(e)} 
                    value={offerDetailsSelected.slots}/>
                    <button className="button-right" onClick={()=>handleSlotChange(1)}>+</button>
                </div>
            </div>
            {(showError || offerDetailsSelected.error )&&<p style={{color: "red",fontFamily: "AmericanSans-Regular"}}>{offerDetailsSelected.error}</p>}
                <button disabled={editCutOffTime || showError} className={`delete-button save-button ${showError&&editCutOffTime&& "disabled"}`} onClick={()=>handleClickSave(offerDetailsSelected.id)}>
                    <img src={saveIcon}/>
                </button>
                {Object.keys(offerDetailsSelected).length > 1 &&
                <button className="delete-button" style={{marginBottom: 20, marginTop: 20}} data-offer-id={offerDetailsSelected.id} id={offerDetailsSelected.id} onClick={(e)=>handleDeleteOffer(e)}>
                    <img src={trashIcon}/>
                </button>}
                </Card.Body>
            </Accordion.Collapse>
        </Card>
    )
}

export default NewOfferComponent;
